import { FeedbackContainer } from 'containers'
import styled from 'styled-components'

const Wrapper = styled.div`
  span {
    margin-right: -25px;
  }
`

const HeaderFeedback = () => {
  return (
    <Wrapper className="pull-left">
      <FeedbackContainer contentType="general-feedback" panel />
    </Wrapper>
  )
}

export default HeaderFeedback
